module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_5_4_1.ffaf2f3f.jpeg";